export enum VerticalMenuTabsEnum {
    GENERAL = 'general',
    PREDICTIVEINTENT_AUTOMATIONS = 'PredictiveIntent Automations',
    EXPORT_ERRORS = 'Export Errors',
}
